import { createFileRoute } from "@tanstack/react-router";
import { RoutedInformation } from "@/components/RoutedInformation";

export const Route = createFileRoute("/terms")({
  component: () => <RoutedInformation section="terms" />,
});
